import { Fragment, useState } from "react";
import styles from "../Table/index.module.scss";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  InputGroup,
  ButtonGroup,
  Button,
  // InputGroupAddon,
  FormGroup,
  Input,
  ModalFooter,
} from "reactstrap";
import DatePicker from "react-datepicker";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useMutation, useQuery } from "@apollo/client";
import { CSO_SEND_INVITATION, SUPPORTER_SEND_INVITATION } from "../mutations";
import { CHECK_USER_STATUS } from "../../../../queries";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";
import LaddaButton, { EXPAND_LEFT } from "react-ladda";

const ModalCreateInvitation = (props) => {
  const { open, setOpenCreateInvitation, refetchStatus } = props;
  const params = useParams();
  const [tool, setTool] = useState(null);
  const [candidateTime1, setCandidateTime1] = useState(
    new Date("2000-01-01 09:00")
  );
  const [candidateTime1PlaceHolder, setCandidateTime1PlaceHolder] =
    useState("");
  const [candidateTime2, setCandidateTime2] = useState(
    new Date("2000-01-01 09:00")
  );
  const [candidateTime2PlaceHolder, setCandidateTime2PlaceHolder] =
    useState("");
  const [candidateTime3, setCandidateTime3] = useState(
    new Date("2000-01-01 09:00")
  );
  const [candidateTime3PlaceHolder, setCandidateTime3PlaceHolder] =
    useState("");
  const [candidateTime4, setCandidateTime4] = useState(
    new Date("2000-01-01 09:00")
  );
  const [candidateTime4PlaceHolder, setCandidateTime4PlaceHolder] =
    useState("");
  const [candidateTime5, setCandidateTime5] = useState(
    new Date("2000-01-01 09:00")
  );
  const [candidateTime5PlaceHolder, setCandidateTime5PlaceHolder] =
    useState("");
  const [url, setUrl] = useState("");
  const [message, setMessage] = useState(null);

  const [mutateInvitation, { loading: isLoadingMutateInvitation }] =
    useMutation(SUPPORTER_SEND_INVITATION);
  const [mutateInvitationByCSO, { loading: isLoadingCsoMutateInvitation }] =
    useMutation(CSO_SEND_INVITATION);

  const userStatus = useQuery(CHECK_USER_STATUS, {
    variables: { email: useUserEmail() },
  });

  const [modalReview, setModalReview] = useState(false);
  const toggleReview = () => setModalReview(!modalReview);

  const toolSelection = (data) => {
    setTool(data);
  };

  const handleChangeCandidateDate1 = (date) => {
    setCandidateTime1(date);
    setCandidateTime1PlaceHolder(date);
  };

  const handleChangeCandidateDate2 = (date) => {
    setCandidateTime2(date);
    setCandidateTime2PlaceHolder(date);
  };

  const handleChangeCandidateDate3 = (date) => {
    setCandidateTime3(date);
    setCandidateTime3PlaceHolder(date);
  };

  const handleChangeCandidateDate4 = (date) => {
    setCandidateTime4(date);
    setCandidateTime4PlaceHolder(date);
  };

  const handleChangeCandidateDate5 = (date) => {
    setCandidateTime5(date);
    setCandidateTime5PlaceHolder(date);
  };

  const handleReviewSubmit = () => {
    toggleReview();
  };

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  const handleSubmitInvitation = () => {
    if (userStatus?.data?.allUsers?.edges[0].node?.isSupporter) {
      mutateInvitation({
        variables: {
          tool: tool,
          url: url,
          message: message,
          candidateDate1: candidateTime1,
          candidateDate2: candidateTime2,
          candidateDate3: candidateTime3,
          candidateDate4: candidateTime4,
          candidateDate5: candidateTime5,
          collaborationStatus: params.id,
        },
      })
        .then((response) => {
          toggleReview();
          setOpenCreateInvitation(!open);
          refetchStatus();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      mutateInvitationByCSO({
        variables: {
          tool: tool,
          url: url,
          message: message,
          candidateDate1: candidateTime1,
          candidateDate2: candidateTime2,
          candidateDate3: candidateTime3,
          candidateDate4: candidateTime4,
          candidateDate5: candidateTime5,
          collaborationStatus: params.id,
        },
      })
        .then((response) => {
          toggleReview();
          setOpenCreateInvitation(!open);
          refetchStatus();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const requiredStyle = {
    padding: "2px 8px",
    marginLeft: "3px",
    backgroundColor: "#f7caca",
    fontSize: "9px",
    color: "#c92d2d",
    borderRadius: "12px",
    border: "1px solid #c92d2d",
  };

  const flexRow = {
    display: "flex",
    flexDirection: "row",
  };

  return (
    <Fragment>
      <div className={styles["create-modal-invitation"]}>
        <Modal
          isOpen={open}
          toggle={() => setOpenCreateInvitation(!open)}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={() => setOpenCreateInvitation(!open)}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              面談調整
            </div>
            <div className="text-center">
              <ButtonGroup className="mb-4">
                <Button
                  outline
                  color="info"
                  // className={toggleStyles["toggle-btn"]}
                  onClick={() => toolSelection("zoom")}
                  active={tool === "zoom"}
                >
                  Zoom
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("google_meet")}
                  active={tool === "google_meet"}
                >
                  Google Meet
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("teams")}
                  active={tool === "teams"}
                >
                  Teams
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("その他")}
                  active={tool === "その他"}
                >
                  その他
                </Button>
              </ButtonGroup>
            </div>
            <FormGroup>
              <Label style={flexRow}>
                候補日
                <span style={requiredStyle}>必須</span>
              </Label>
            </FormGroup>
            <InputGroup>
              <DatePicker
                selected={candidateTime1PlaceHolder}
                showMonthDropdown
                showYearDropdown
                onChange={handleChangeCandidateDate1}
                showTimeSelect
                className="form-control mb-2"
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="Pp"
                timeCaption="Time"
                placeholderText="日程選択 (必須)"
                minDate={moment().toDate()}
                filterTime={filterPassedTime}
              />
              {/* <InputGroupAddon addonType="append">
                <div className="input-group-text">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon> */}
            </InputGroup>
            <InputGroup>
              <DatePicker
                className="form-control mb-2"
                selected={candidateTime2PlaceHolder}
                showMonthDropdown
                showYearDropdown
                onChange={handleChangeCandidateDate2}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="Pp"
                timeCaption="Time"
                placeholderText="日程選択 (必須)"
                minDate={moment().toDate()}
                filterTime={filterPassedTime}
              />
              {/* <InputGroupAddon addonType="append">
                <div className="input-group-text">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon> */}
            </InputGroup>
            <InputGroup>
              <DatePicker
                selected={candidateTime3PlaceHolder}
                onChange={handleChangeCandidateDate3}
                showTimeSelect
                className="form-control mb-2"
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="Pp"
                timeCaption="Time"
                placeholderText="日程選択"
                minDate={moment().toDate()}
                filterTime={filterPassedTime}
              />
              {/* <InputGroupAddon addonType="append">
                <div className="input-group-text">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon> */}
            </InputGroup>
            <InputGroup>
              <DatePicker
                selected={candidateTime4PlaceHolder}
                onChange={handleChangeCandidateDate4}
                showTimeSelect
                className="form-control mb-2"
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="Pp"
                timeCaption="Time"
                placeholderText="日程選択"
                minDate={moment().toDate()}
                filterTime={filterPassedTime}
              />
              {/* <InputGroupAddon addonType="append">
                <div className="input-group-text">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon> */}
            </InputGroup>
            <InputGroup>
              <DatePicker
                selected={candidateTime5PlaceHolder}
                onChange={handleChangeCandidateDate5}
                showTimeSelect
                className="form-control mb-2"
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="Pp"
                timeCaption="Time"
                placeholderText="日程選択"
                minDate={moment().toDate()}
                filterTime={filterPassedTime}
              />
              {/* <InputGroupAddon addonType="append">
                <div className="input-group-text">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon> */}
            </InputGroup>
            <FormGroup className="mt-2">
              <Label style={flexRow}>URL</Label>
              <Input
                type="text"
                name="url"
                className="form-control"
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com"
              />
            </FormGroup>
            <FormGroup>
              <Label style={flexRow}>
                その他
                <span style={requiredStyle}>必須</span>
              </Label>
              <Input
                required
                type="textarea"
                name="message"
                className="form-control"
                onChange={(e) => setMessage(e.target.value)}
                placeholder="自由記述"
              />
            </FormGroup>
            <FormGroup className="pull-right">
              {message &&
              tool &&
              candidateTime1PlaceHolder &&
              candidateTime2PlaceHolder ? (
                <Button color="info" onClick={handleReviewSubmit}>
                  次へ
                </Button>
              ) : (
                <Button color="info" disabled>
                  次へ
                </Button>
              )}
            </FormGroup>
          </ModalBody>
        </Modal>
      </div>
      <div className={styles["review-invitation"]}>
        <Modal
          isOpen={modalReview}
          toggle={toggleReview}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggleReview}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              面談調整
            </div>
            <div className="text-center">
              <ButtonGroup className="mb-4">
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("zoom")}
                  active={tool === "zoom"}
                >
                  Zoom
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("google_meet")}
                  active={tool === "google_meet"}
                >
                  Google Meet
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("teams")}
                  active={tool === "teams"}
                >
                  Teams
                </Button>
                <Button
                  outline
                  color="info"
                  onClick={() => toolSelection("その他")}
                  active={tool === "その他"}
                >
                  その他
                </Button>
              </ButtonGroup>
            </div>
            <FormGroup>
              <Label>候補日</Label>
              <ul>
                {candidateTime1 !== "" && (
                  <li>
                    {moment(candidateTime1).format("YYYY年MM月DD日 HH:mm")}
                  </li>
                )}
                {candidateTime2 !== "" && (
                  <li>
                    {moment(candidateTime2).format("YYYY年MM月DD日 HH:mm")}
                  </li>
                )}
                {candidateTime3PlaceHolder !== "" && (
                  <li>
                    {moment(candidateTime3).format("YYYY年MM月DD日 HH:mm")}
                  </li>
                )}
                {candidateTime4PlaceHolder !== "" && (
                  <li>
                    {moment(candidateTime4).format("YYYY年MM月DD日 HH:mm")}
                  </li>
                )}
                {candidateTime5PlaceHolder !== "" && (
                  <li>
                    {moment(candidateTime5).format("YYYY年MM月DD日 HH:mm")}
                  </li>
                )}
              </ul>
            </FormGroup>
            <FormGroup>
              <Label>URL</Label>
              <br />
              {url}
            </FormGroup>
            <FormGroup>
              <Label>その他</Label> <br />
              {message}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {/* <Button color="info" onClick={handleSubmitInvitation}>
              送信
            </Button> */}
            <LaddaButton
              className="mb-2 mr-2 btn btn-info"
              style={{ backgroundColor: "#44CAE1", borderColor: "#44CAE1" }}
              loading={isLoadingCsoMutateInvitation}
              onClick={handleSubmitInvitation}
              data-style={EXPAND_LEFT}
            >
              送信
            </LaddaButton>
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
};

export default ModalCreateInvitation;
